<!--
 * @Description: 支付筛选页
 * @Date: 2020-12-11 18:32:30
-->
<template>
  <div class="to-settlement">
    <div style="text-align: right">
      <el-row :gutter="10" type="flex" justify="end" v-if="isOnline">
        <el-col :span="6" v-loading="balanceLoading">
          账户余额：{{ balance | moneyFixed }}
        </el-col>
      </el-row>
      <el-row :gutter="10" type="flex" justify="space-between">
        <el-col style="text-align:left;padding:0 1.56vw;margin-left:12px">
          <div
            style="line-height:24px;height:24px;border-left:8px solid #409eff;text-indent:1em"
          >
            订单
          </div>
        </el-col>

        <el-col :span="12" style="margin-top: 10px">
          <div>
            <span style="margin-right: 20px">订单数：{{ dataCount }}笔</span>
            <span>打款金额合计：{{ sumAmount | moneyFixed }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <table-render
      ref="tableRender"
      :rowKey="rowKey"
      :config="config"
      :getListFinished="getListFinished"
      height="52vh"
    />
    <!-- 线上展示 -->
    <p
      v-show="balance != '-' && sumAmount > balance"
      v-if="isOnline"
      style="text-align:center;color:red"
    >
      您当前所选订单支付金额超过您当前账户余额，请重新选择。
    </p>
    <div class="xrk-dialog__btns">
      <el-button @click="close">返回</el-button>
      <el-button type="primary" @click="confirm" :disabled="confirmDisabled">
        确认
      </el-button>
    </div>
  </div>
</template>

<script>
import { totalNoPayCsoCustomOrder, getBalance } from '@/api/ajax';
import { toPayOrders } from '../config';
import tableRender from '@/components/tableRender';
import {
  isRevokePeople,
  formatOrdersFieldByType
} from '@/page/settlementCenter/utils';

const rowKey = 'idPriceType';
/**
 * @description: 整理选中的数据，转为json
 * @param {array} data 已选中数据
 * @return {string} json 整理后的数据
 */
const stringifyPreSelection = data => {
  let result = [];
  data.forEach(({ priceType, csoCustomOrderIds, id }) => {
    const ids = (csoCustomOrderIds || id + '').split(',').map(item => {
      return {
        id: item,
        priceType
      };
    });
    [].push.apply(result, ids);
  });
  return JSON.stringify(result);
};
const getPreSelectionIdPriceType = data => {
  const result = [];
  data.forEach(
    ({ priceType, noPayCsoCustomOrderIds, csoCustomOrderIds, id }) => {
      // 批次数据中使用noPayCsoCustomOrderIds作为选中数据
      const customOrderIds =
        typeof noPayCsoCustomOrderIds === 'string'
          ? noPayCsoCustomOrderIds
          : csoCustomOrderIds;
      const ids = (customOrderIds || id + '').split(',').map(item => {
        return {
          idPriceType: `${item}_${priceType}`,
          csoCustomOrderIds: item,
          priceType
        };
      });
      [].push.apply(result, ids);
    }
  );
  return result;
};

export default {
  name: 'ToPayOrder',
  cname: '前往支付',
  props: {
    // 上个页面的已选数据
    preSelection: {
      type: Array,
      default() {
        return [];
      }
    },
    userEnterpriseType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      rowKey,
      balance: '-', // 账户余额
      dataCount: '', // 订单数
      sumAmount: '', // 总金额
      config: null,
      selection: [],
      balanceLoading: true
    };
  },
  components: { tableRender },
  computed: {
    isOnline() {
      return this.$store.state.orderMgmt.payType === 1;
    },
    confirmDisabled() {
      // 无选项、加载接口，禁用
      if (!this.selection.length || this.balanceLoading) {
        return true;
      }
      // 线上走金额判断
      if (this.isOnline) {
        return this.sumAmount > this.balance;
      }
      // 线下无需判断金额
      return false;
    }
  },
  watch: {
    selection: {
      deep: true,
      handler(v) {
        this.getCurrentSelectionInfo(v);
      }
    }
  },
  methods: {
    // 获取当前所选订单钱、数
    async getCurrentSelectionInfo(selection) {
      if (selection.length) {
        // 注： 父级传入时为csoCustomOrderId，当前组件勾选后使用id
        const query = formatOrdersFieldByType(
          this.selection,
          'csoCustomOrderIds'
        );
        let { pdata } = await totalNoPayCsoCustomOrder({
          ...query,
          userEnterpriseType: this.userEnterpriseType
        });
        Object.assign(this.$data, pdata);
      } else {
        Object.assign(this.$data, { dataCount: 0, sumAmount: '' });
      }
    },
    async confirm() {
      await isRevokePeople(this.selection);
      const query = formatOrdersFieldByType(this.selection);
      let noValue = Object.values(query).every(item => item === '');
      if (noValue) {
        this.$message.error('没有需要支付的订单');
        return false;
      }
      this.$xrkDialog({
        title: '确认支付',
        showConfirm: false,
        showCancel: false,
        $slots: {
          default: this.$createElement(require('./orderPay').default, {
            props: {
              ...query
            }
          })
        }
      });
    },
    close() {
      this.$xrkDialog.remove();
    },
    getListFinished() {
      this.balance = 0;
      getBalance()
        .then(({ pdata }) => {
          const balanceMap = {
            zbBank: 'zbMoneyBalance',
            fyBank: 'fyMoneyBalance'
          };
          this.balance =
            pdata[
              balanceMap[this.$refs.tableRender.tableData[0].payPassagewayCode]
            ];
        })
        .catch(err => {
          this.$confirm(err.message, '错误提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'error'
          });
        })
        .finally(() => {
          this.balanceLoading = false;
        });
    }
  },
  async created() {
    this.preSelection.map(item => {
      if (!item.priceType) {
        item.priceType = 2;
      }
    });
    toPayOrders[0].childMenu[0].defaultQuery = {
      // 这个参数后端要求只有id和priceType。  = =
      chooseOrderJson: stringifyPreSelection(this.preSelection)
    };
    this.config = toPayOrders;
    this.$nextTick(() => {
      // 同步选项
      this.$refs.tableRender.selectAllByRowKey({
        superKeys: getPreSelectionIdPriceType(this.preSelection),
        useSeachInit: false
      });
      // 便于监听数据变化
      this.selection = this.$refs.tableRender.$refs.table.selection;
    });
  }
};
</script>

<style scoped lang="scss">
.to-settlement {
  width: 70vw;
}
</style>
